export default __webpack_public_path__ + "static/media/setting.a26d47ee.svg";